<template>
  <EditorNodeWrapper :class="['node-container', rowTypeClass, blockWidthClass]">
    <ResourcePlaceholder
      v-if="node?.placeholder?.type === PlaceholderType.Resource"
      :node="node"
      :placeholder="placeholder"
    />
    <ElementPlaceholder v-else :node="node" />
  </EditorNodeWrapper>
</template>

<script setup lang="ts">
import type {
  EBlockWidth,
  MappedContentPlaceholder,
  ContentPlaceholder,
} from '@getaccept/editor-lib';
import { PlaceholderType } from '@getaccept/editor-lib';
import EditorNodeWrapper from '../EditorNodeWrapper.vue';
import ResourcePlaceholder from './ResourcePlaceholder.vue';
import ElementPlaceholder from './ElementPlaceholder.vue';

defineProps<{
  node: ContentPlaceholder;
  blockWidthClass?: EBlockWidth;
  rowTypeClass?: string;
  placeholder?: MappedContentPlaceholder;
}>();
</script>
